<template>
  <Modal title="编辑会员" v-model="isShow" @on-cancel="handle">
    <Form ref="formInfo"  :model='formInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
      <form-item label="昵称" prop="nickname">
        <Input placeholder="请输入昵称" v-model="formInfo.nickname" disabled></Input>
      </form-item>
      <form-item label="手机号" prop="phone">
        <Input placeholder="请输入手机号" v-model="formInfo.phone" disabled></Input>
      </form-item>
      <form-item label="微信号" prop="wechat">
        <Input placeholder="请输入微信号" v-model="formInfo.wechat"></Input>
      </form-item>
<!--      <form-item label="是否为官方甄选家" prop="type" >-->
<!--        <RadioGroup v-model="formInfo.is_admin_official_auth">-->
<!--          <Radio :label="1">是</Radio>-->
<!--          <Radio :label="0">否</Radio>-->
<!--        </RadioGroup>-->
<!--      </form-item>-->
      <form-item label="是否为甄选家" prop="is_official_auth">
        <RadioGroup v-model="formInfo.is_official_auth">
          <Radio :label="1">是</Radio>
          <Radio :label="0">否</Radio>
        </RadioGroup>
      </form-item>
      <form-item label="会员等级" prop="type" v-if="formInfo.is_official_auth==1">
        <RadioGroup v-model="formInfo.office_level">
          <Radio :label="0" class="radio">无</Radio>
          <Radio :label="1">白银</Radio>
          <Radio :label="2">黄金</Radio>
          <Radio :label="3">铂金</Radio>
          <Radio :label="4">钻石</Radio>
        </RadioGroup>
      </form-item>

      <form-item label="节省多少钱" prop="saving_fee">
        <Input placeholder="请输入节省多少钱" v-model="formInfo.saving_fee"></Input>
      </form-item>
      <form-item label="已住民宿多少晚" prop="homes_checkIn_num">
        <Input placeholder="请输入已住民宿多少晚" v-model="formInfo.homes_checkIn_num"></Input>
      </form-item>
    </Form>
    <div slot="footer">
      <Button type="primary"   @click="handleOk('formInfo')">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { userEdit, userInfo } from '@/api/user'
import Setting from '@/setting'
export default {
  name: 'userEdit',
  props: ['editShow', 'edituserid'],
  data () {
    return {
      formInfo: {
        user_id: 0,
        nickname: '',
        phone: '',
        wechat: '',
        is_admin_official_auth: 0,
        office_level: 1,
        is_official_auth: 1,
        saving_fee: 0,
        homes_checkIn_num: 0
      },
      uploadList: [], // 缩咯图
      server_url: Setting.serverSrc,
      serverApiPic: Setting.serverApiPic,
      isShow: false,
      imgUrl: '',
      user_id: 0,
      visible: false,
      ruleValidate: {
      }
    }
  },
  watch: {
    editShow (val) {
      if (val && this.user_id > 0 && this.user_id === this.formInfo.user_id) {
        this.getUserInfo()
      }
      this.isShow = val
      if (this.user_id === 0) {
        this.formInfo.user_id = 0
        this.formInfo.nickname = ''
        this.formInfo.phone = ''
        this.formInfo.wechat = ''
        this.formInfo.delpics = []
        this.formInfo.is_admin_official_auth = 0
        this.formInfo.is_official_auth = 0
        this.formInfo.saving_fee = 0
        this.formInfo.homes_checkIn_num = 0
      }
      this.uploadList = []
    },
    edituserid (val) {
      console.log(222)
      this.user_id = val
      this.formInfo.user_id = val
      console.log(val)
      if (this.user_id > 0) {
        this.getUserInfo()
      }
    }
  },
  methods: {
    handle () {
      this.$emit('updateStatusModel', false)
    },
    // 获取信息
    getUserInfo () {
      userInfo(this.user_id).then(res => {
        if (res.code === 200) {
          this.formInfo = res.data
          this.formInfo.delpics = []
          this.uploadList.push({ 'url': this.formInfo.avatar, 'showProgress': false, 'percentage': 100, 'status': 'finished' })
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    handleOk (name) {
      userEdit(this.formInfo).then(res => {
        if (res.code === 200) {
          this.$Message.success(res.msg)
          this.$emit('updateStatusModel', false)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    handleView (url) {
      this.imgUrl = url
      this.visible = true
    },
    // 缩略图删除
    handleRemove (file) {
      const fileList2 = this.uploadList
      this.advertInfos.delpics.push(file.url)
      this.uploadList.splice(fileList2.indexOf(file), 1)
      this.uploadList = []
    },
    // 缩略图
    handleSuccess (res, file) {
      let file_url = res.data.file_url
      if (file_url.substring(0, 5) === 'https') {
        file.url = file_url
      } else {
        file.url = this.server_url + file_url
      }
      this.uploadList = this.$refs.uploadThumb.fileList
    },
    handleFormatError (file) {
      this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
    },
    handleMaxSize (file) {
      this.$Message.error('文件' + file.name + '太大，不能大于10M')
    },
    // 缩略图
    handleBeforeUpload () {
      const check = this.uploadList.length < 1
      if (!check) {
        this.$Message.error('只能上传1张图片')
      }
      return check
    }
  }
}
</script>
